import { Injectable } from '@angular/core';
import { TimeZoneEnum } from '@zaoblako/shared/common/enums/time.zone.enum';
import { TenantService } from '@zaoblako/web/core/services/security/tenant.service';

const LOCAL_STORAGE_ID = 'TENANT_TIME_ZONE';

@Injectable({
  providedIn: 'root'
})
export class CurrentTimeZoneService {
  public constructor(private readonly tenantService: TenantService) {}

  /** Get cached tenant time zone */
  public getTimeZone(): TimeZoneEnum {
    return (localStorage.getItem(LOCAL_STORAGE_ID) as TimeZoneEnum) || TimeZoneEnum.EUROPE_MOSCOW;
  }

  /** Set cached tenant time zone */
  public setTimeZone(value: TimeZoneEnum): void {
    localStorage.setItem(LOCAL_STORAGE_ID, value);
  }

  /** Get tenant time zone from server and cache it */
  public refreshTimeZone(): void {
    this.tenantService.getCurrent().subscribe((tenant) => localStorage.setItem(LOCAL_STORAGE_ID, tenant.timezone));
  }
}
